//请求接口api地址

const api = {
    // name: 'path',//示例
    consumer:'user.index/user',//用户信息
    flowState:'user.index/audit',//流程状态

    uploadFile:'upload/uploadFile',//全局文件上传
    // uploadFile:'uploads/uploadFile',//全局文件上传
    captcha:'login.login/captcha',// 验证码
    login:'login.login/index.html',// 登陆注册

    gettips:'login.login/gettips',// 供应商类型提示
    categoryList:'index/categoryList',// 供应商类型和分类
    category:'user.index/category',// 供应商类型分类下一步
    editinfo:'supplier.supplier/editinfo.html',// 企业概况1.下一步 2.保存草稿
    editFactory:'supplier.supplier/editFactory',// 工厂概况1.下一步 2.保存草稿
    editSupply:'supplier.supplier/editSupply',// 产品概况1.下一步 2.保存草稿
    firstTrial:'supplier.supplier/uploadExcel.html',// 提交初审
    firstTrialDown:'user.index/export.html',// 初审提交页面的下载
    firstTrialDraft:'supplier.supplier/info',// 查看初审保存草稿

    learningDraft:'survey.index/ipr',// 知识产权查看保存草稿
    learning:'survey.index/editipr',// 知识产权1.下一步 2.保存草稿
    learningDown:'survey.index/exportip.html',// 知识产权下载
    safetyDraft:'survey.index/safe',// 信息安全调查表查看保存草稿
    safety:'survey.index/editsafe',// 信息安全调查表1.下一步 2.保存草稿
    safetyDown:'survey.index/exportSafe.html',// 信息安全调查表查下载
    accessoryDraft:'survey.index/accessory',// 附件 查看保存草稿
    accessory :'survey.index/editaccessory',// 附件1.下一步 2.保存草稿

    particulars:'user.index/userInfo',// 审批完查看详情接口

    putForms:'survey.index/uploadsurvey',// 上传1.知识产权表 2.信息安全表

    downInstructor:'login.login/book.html',// 下载操作指导书
    pvwInstructor:'login.login/bookimg.html',// 预览操作指导书

    refer:'login.login/supplier.html',// 文档上传参考

    inDetail:'survey.index/editdetails',// 保存提交详细信息

    examineDetails:'survey.index/details',// 查看保存详细信息

    sole:'index/url',// 底部链接

    questionnaire:'supplier.supplier/uploadSupplier',// 上传供应商调查表
}

export default api;


// WEBPACK FOOTER //
// ./src/utils/api.js